<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="ppm.pages.task_history"> </sm-page-header>
  <!-- content -->
  <div class="content">
    <sm-data-table-builder [dataTableObject]="datatableObject" [datas]="data" [loading]="loading"></sm-data-table-builder>
  </div>
</div>
